export default "__VITE_ASSET__Bw8069AZ__"